import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { BackButton } from '../components/BackButton';
import { Page } from '../components/PageLayout';
import { CirclesUpcomingTopicsByLanguage } from '../components/CirclesUpcomingTopicsByLanguage';
import { CircleCenteredBanner } from '../components/CircleCenteredBanner';

import {
    CirclesOnDemandByLanguageSection,
    useTranslatedLanguage,
} from './CirclesOnDemandOverviewPage';

interface LanguagePageParams {
    languageCode: string;
}

export const CirclesOnDemandLanguagePage = () => {
    const { t } = useTranslation('circles');

    const { languageCode } = useParams<LanguagePageParams>();
    const language = useTranslatedLanguage(languageCode, languageCode);
    const header = t('pages.on_demand_by_language.header', { language });
    const description = t('pages.on_demand_by_language.description', { language });

    return (
        <Page.Container>
            <Page.Header>
                <BackButton />
            </Page.Header>

            <Page.Content
                css={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 32,
                }}
            >
                <CircleCenteredBanner header={header} description={description} />
                <CirclesOnDemandByLanguageSection
                    heading={t('sections.on_demand.header')}
                    key={languageCode}
                    languageCode={languageCode}
                />
                <CirclesUpcomingTopicsByLanguage languageCode={languageCode} />
            </Page.Content>
        </Page.Container>
    );
};
